"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("./Support/BaseUri");
var Request = require("./Support/Request");
function login(attempt) {
    var url = BaseUri.compose('cookies', 'authorize')
        .toString();
    return Request.postJson(url, attempt);
}
exports.login = login;
function logout() {
    var url = BaseUri.compose('cookies', 'logout')
        .toString();
    return Request.postJsonOk(url, {});
}
exports.logout = logout;
function register(registration) {
    var url = BaseUri.compose('account', 'create')
        .toString();
    return Request.postJsonOk(url, registration);
}
exports.register = register;
function forgot(emailAddress, urlFormat) {
    var url = BaseUri.compose('account', 'forgot')
        .toString();
    return Request.postJsonOk(url, { emailAddress: emailAddress, urlFormat: urlFormat });
}
exports.forgot = forgot;
function reset(guid, password) {
    var url = BaseUri.compose('account', 'reset')
        .toString();
    return Request.postJsonOk(url, { guid: guid, password: password });
}
exports.reset = reset;
function placeOrder(order) {
    var url = BaseUri.compose('tryks', 'order')
        .toString();
    return Request.postJson(url, order);
}
exports.placeOrder = placeOrder;
function getAccount() {
    var url = BaseUri.compose('account')
        .toString();
    return Request.getJson(url);
}
exports.getAccount = getAccount;
function updateContact(contact) {
    var url = BaseUri.compose('account', 'update')
        .toString();
    return Request.postJsonOk(url, contact);
}
exports.updateContact = updateContact;
function changePassword(request) {
    var url = BaseUri.compose('account', 'update', 'password')
        .toString();
    return Request.postJsonOk(url, request);
}
exports.changePassword = changePassword;
function getShippingHistory() {
    var url = BaseUri.compose('shipping', 'history')
        .toString();
    return Request.getJson(url);
}
exports.getShippingHistory = getShippingHistory;
function shareDesign(request) {
    var url = BaseUri.compose('share', 'design')
        .toString();
    return Request.postJsonOk(url, request);
}
exports.shareDesign = shareDesign;
